//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React from 'react';

import { Redirect }    from 'react-router';
import { useLocation } from 'react-router';

import Routes from '@constants/Routes';

const PasswordLostScreen = () => {
    const location     = useLocation();
    const searchParams = location.search;

    return (
        <Redirect
            to={`${Routes.passwordReset}${searchParams}`}
        />
    );
};

export default PasswordLostScreen;
